/**
 * Weight, italic and capitals per text role in the CI (spec 2026-09-24
 * Textstil §3.1, weight since spec 2026-09-29 §1.4), shared by the project
 * and folder settings. kursiv/gross: '' (theme default), 'ja' or 'nein',
 * stored as true/false. staerke: a number 100-900, stored as that number.
 * schrift: a font name (own font of the role), stored trimmed, '' removes it.
 */
import Vue from 'vue';
import { ROLE_STYLE_ROLES, TYPE_WEIGHTS } from '@/editor-v2/utils/ciTokens';

export { ROLE_STYLE_ROLES };
export const ROLLEN_STIL_FELDER = Object.freeze(['staerke', 'kursiv', 'gross']);

export function rollenStilWert(typo, role, feld) {
  const wert = typo && typo.roleStyles && typo.roleStyles[role] && typo.roleStyles[role][feld];
  if (feld === 'schrift') return typeof wert === 'string' ? wert : '';
  if (feld === 'staerke') return TYPE_WEIGHTS.includes(wert) ? wert : '';
  if (wert === true) return 'ja';
  if (wert === false) return 'nein';
  return '';
}

function gespeicherterWert(feld, wahl) {
  if (feld === 'staerke') return TYPE_WEIGHTS.includes(Number(wahl)) ? Number(wahl) : undefined;
  if (wahl === 'ja' || wahl === 'nein') return wahl === 'ja';
  return undefined;
}

/** Sets or clears one value; empty roles and an empty map are removed. */
export function rollenStilSetzen(typo, role, feld, wahl) {
  if (!typo.roleStyles) Vue.set(typo, 'roleStyles', {});
  if (!typo.roleStyles[role]) Vue.set(typo.roleStyles, role, {});
  const wert = feld === 'schrift' ? (String(wahl || '').trim() || undefined) : gespeicherterWert(feld, wahl);
  if (wert === undefined) Vue.delete(typo.roleStyles[role], feld);
  else Vue.set(typo.roleStyles[role], feld, wert);
  if (Object.keys(typo.roleStyles[role]).length === 0) Vue.delete(typo.roleStyles, role);
  if (Object.keys(typo.roleStyles).length === 0) Vue.delete(typo, 'roleStyles');
}
